import Task from "../../../core/model2/task/task"
import AppTaskView from "../app"
import taskView_checkTimeReportAccess from "./check-time-report-access"

export default function taskView_stopTimer(task?: Task) {

    if (!taskView_checkTimeReportAccess()) {
        return
    }

    if (!task) {
        const app : AppTaskView = gd.getApp() as unknown as AppTaskView
        task = app.task
    }

    gd.taskTimers.stopTimer(task.id, moment(task.momentCreated))
}